module.exports = __webpack_public_path__ + "img/tecdoc_inside.58ac55b5.png";